import { useRef } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import {
  faMap,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/pro-regular-svg-icons';

import MaplibreMap from '@App/components/MaplibreMap/MaplibreMap';
import CaseStudySectionHeader from '@App/pages/CaseStudy/CaseStudySectionHeader/CaseStudySectionHeader';

import './case-study-map-card.css';

function CaseStudyMapCard({
  children,
  className = '',
  headerIcon = faMap,
  initialCenter,
  initialZoom,
  showNavigationControls = true,
  label = 'Map',
}) {
  const mapRef = useRef(null);

  return (
    <div className={`case-study-map-card ${className}`.trim()}>
      <div className="case-study-map-card__header">
        <CaseStudySectionHeader label={label} icon={headerIcon} />
        <Button
          layout="ghost"
          hover={false}
          icon={faUpRightAndDownLeftFromCenter}
          className="case-study-map-card__expand"
          color="var(--color-common-grey-dark)"
          onClick={() => mapRef.current?.requestFullscreen?.()}
        />
      </div>
      <MaplibreMap
        ref={mapRef}
        className="case-study-map-card__map"
        initialCenter={initialCenter}
        initialZoom={initialZoom}
        showNavigationControls={showNavigationControls}
      >
        {children}
      </MaplibreMap>
    </div>
  );
}

export default CaseStudyMapCard;
